import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__requested_amount__",
        fields: [
            {
                // label: 'Desired Loan Amount',
                name: 'requested_amount',
                placeholder: '50000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                // type: 'radio',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                // choices: [
                //     {"text": "__opt_1000_less__", "value": "750"},
                //     {"text": "__opt_1001_5000__", "value": "3500"},
                //     {"text": "__opt_5001_10000__", "value": "7500"},
                //     {"text": "__opt_10001_15000__", "value": "15000"},
                //     {"text": "__opt_15001_20000__", "value": "20000"},
                //     {"text": "__opt_20000_more__", "value": "25000"},
                // ],
                hideIfHasValue: true,
                attrs: {
                    maxlength: 7
                },
            },
        ],
        // hideIfCondition: (app) => {
        //     return app.projectBrandKey && app.projectBrandKey == 'pq';
        // },
        hideButtonsSection: false,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__postal_code__",
        fields: [
            {
                // label: 'Desired Loan Amount',
                name: 'postal_code',
                placeholder: 'A9A9A9',
                // prependInputSpan: '$',
                // appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|postal',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: true,
                attrs: {
                    maxlength: 6
                },
            },
        ],
        // hideIfCondition: (app) => {
        //     return app.projectBrandKey && app.projectBrandKey == 'pq';
        // },
        // hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__business_start_date__",
        fields: [
            {
                // label: 'What is your date of birth?',
                name: 'business_start_date',
                placeholder: null,
                as: 'input',
                type: 'date',
                value: null,
                validationRules: 'required|date',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
            },
        ],
    },
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
        },
        title: "__in_credit_situation__",
        fields: [
            {
                // label: 'Loan Purpose',
                // name: 'credit_score',
                name: 'in_credit_situation',
                placeholder: '__select__',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    {"text": "__opt_in_credit_situation_cp__", "value":"in_consumer_proposal"},
                    {"text": "__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__citizen_status__",
        fields: [
            {
                // label: 'Citizenship Status',
                name: 'canadian_status',
                placeholder: '',
                as: 'input',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_cs_citizen__", "value":"citizen" },
                    { "text":"__opt_cs_permanent__", "value":"pr" },
                    { "text":"__opt_cs_work__", "value":"work_permit" },
                    { "text":"__opt_cs_student__", "value":"student_visa" },
                    { "text":"__opt_cs_visitor__", "value":"other" },
                    { "text":"__opt_cs_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__notice_of_assessment__',
        // textTop: '__noa_last_year__',
        fields: [
            {
                label: '__last_years_income__',
                name: 'income_noa_1',
                placeholder: '60000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 8
                },
                hideIfHasValue: true,
            },
            {
                label: '__year_before_last_income__',
                name: 'income_noa_2',
                placeholder: '50000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 8
                },
                hideIfHasValue: true,
            },
        ],
        // hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__business_assets__',
        // textTop: '__noa_last_year__',
        fields: [
            {
                label: '__liquid_equity__',
                name: 'equity_liquid',
                placeholder: '20000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 8
                },
                hideIfHasValue: true,
            },
            {
                label: `__non_liquid_equity__`,
                name: 'equity_non_liquid',
                placeholder: '50000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 8
                },
                hideIfHasValue: true,
            },
        ],
        // hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__company_information__',
        // textTop: '__unsecured_debt_amount_definition__',
        fields: [
            {
                label: '__company_name__',
                name: 'company_name',
                // placeholder: '60000',
                // prependInputSpan: '$',
                // appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 100
                },
            },
            {
                label: '__gross_sales_monthly__',
                name: 'monthly_gross_sales',
                placeholder: '50000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 7
                },
            },
            {
                label: '__gross_sales_cards__',
                name: 'monthly_card_sales',
                placeholder: '50000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 7
                },
            },
            {
                label: '__industry__',
                name: 'business_type',
                placeholder: '',
                as: 'input',
                type: 'select',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"value":"ACCOUNTING", "text":"__opt_business_type_accounting__"},
                    {"value":"AGRICULTURE_FARMING", "text":"__opt_business_type_agriculture__"},
                    {"value":"ANIMAL_BOARDING", "text":"__opt_business_type_animal_boarding__"},
                    {"value":"APPAREL_ACCESSORIES", "text":"__opt_business_type_apparel_accessories__"},
                    {"value":"AUTO_TRUCK_DEALERSHIP", "text":"__opt_business_type_auto_dealership__"},
                    {"value":"AUTO_BODY", "text":"__opt_business_type_auto_body__"},
                    {"value":"AUTO_RENTAL", "text":"__opt_business_type_auto_rental__"},
                    {"value":"BEAUTY_SALON_BARBER_SHOP", "text":"__opt_business_type_beauty_barber__"},
                    {"value":"BUILDING_MATERIALS", "text":"__opt_business_type_building_materials__"},
                    {"value":"BUSINESS_SERVICES", "text":"__opt_business_type_business_services__"},
                    {"value":"CAR_WASH", "text":"__opt_business_type_car_wash__"},
                    {"value":"CELLULAR_WIRELESS_STORE", "text":"__opt_business_type_cellular_store__"},
                    {"value":"CHILD_EDUCATION", "text":"__opt_business_type_child_education__"},
                    {"value":"CONSULTING", "text":"__opt_business_type_consulting__"},
                    {"value":"DAY_CARE_SERVICES", "text":"__opt_business_type_day_care__"},
                    {"value":"DOCTOR", "text":"__opt_business_type_doctor__"},
                    {"value":"ELECTRONICS_COMPUTERS", "text":"__opt_business_type_electronics_computers__"},
                    {"value":"ENTERTAINMENT", "text":"__opt_business_type_entertainment__"},
                    {"value":"EQUIPMENT_RENTAL", "text":"__opt_business_type_equipment_rental__"},
                    {"value":"FABRICATION", "text":"__opt_business_type_fabrication__"},
                    {"value":"FINANCIAL_SERVICES", "text":"__opt_business_type_financial_services__"},
                    {"value":"FRANCHISE", "text":"__opt_business_type_franchise__"},
                    {"value":"FUNERAL_HOME", "text":"__opt_business_type_funeral_home__"},
                    {"value":"GAMING", "text":"__opt_business_type_gaming__"},
                    {"value":"GAS_STATION", "text":"__opt_business_type_gas_station__"},
                    {"value":"GENERAL_CONTRACTOR", "text":"__opt_business_type_general_contractor__"},
                    {"value":"GENERAL_MERCHANDISE_STORE", "text":"__opt_business_type_general_merchandise_store__"},
                    {"value":"GROCERY_CONVENIENCE_STORE", "text":"__opt_business_type_grocery_convenience_store__"},
                    {"value":"GUNS_AMMUNITION_STORE", "text":"__opt_business_type_guns_ammunition_store__"},
                    {"value":"GYM_FITNESS_TRAINER", "text":"__opt_business_type_gym_fitness_trainer__"},
                    {"value":"HEALTH_SERVICES", "text":"__opt_business_type_health_services__"},
                    {"value":"HOME_FURNISHINGS", "text":"__opt_business_type_home_furnishings__"},
                    {"value":"HOTEL_MOTEL", "text":"__opt_business_type_hotel_motel__"},
                    {"value":"HVAC", "text":"__opt_business_type_hvac__"},
                    {"value":"INSURANCE_BROKERS", "text":"__opt_business_type_insurance_brokers__"},
                    {"value":"INTERNET_RETAILER", "text":"__opt_business_type_internet_retailer__"},
                    {"value":"LANDSCAPING_SERVICES", "text":"__opt_business_type_landscaping_services__"},
                    {"value":"LAUNDRY_GARMENT_SERVICES", "text":"__opt_business_type_laundry_garment_services__"},
                    {"value":"LAW_FIRM", "text":"__opt_business_type_law_firm__"},
                    {"value":"LEGAL_COUNSEL", "text":"__opt_business_type_legal_counsel__"},
                    {"value":"LOCKSMITH", "text":"__opt_business_type_locksmith__"},
                    {"value":"MANUFACTURING", "text":"__opt_business_type_manufacturing__"},
                    {"value":"MARKETING", "text":"__opt_business_type_marketing__"},
                    {"value":"MEDIA_PRODUCTION", "text":"__opt_business_type_media_production__"},
                    {"value":"MEDICAL_HEALTHCARE", "text":"__opt_business_type_medical_healthcare__"},
                    {"value":"NAIL_SALON", "text":"__opt_business_type_nail_salon__"},
                    {"value":"OIL_INDUSTRY", "text":"__opt_business_type_oil_industry__"},
                    {"value":"OTHER", "text":"__opt_business_type_other__"},
                    {"value":"PHOTOGRAPHY_STUDIO", "text":"__opt_business_type_photography_studio__"},
                    {"value":"POOL_SERVICES", "text":"__opt_business_type_pool_services__"},
                    {"value":"PRINTING", "text":"__opt_business_type_printing__"},
                    {"value":"REAL_ESTATE_RELATED", "text":"__opt_business_type_real_estate_related__"},
                    {"value":"RECREATION", "text":"__opt_business_type_recreation__"},
                    {"value":"RESIDENTIAL_CONTRACTOR", "text":"__opt_business_type_residential_contractor__"},
                    {"value":"RESTAURANT_CAFE_BAR", "text":"__opt_business_type_restaurant_cafe_bar__"},
                    {"value":"RETAIL_STORE", "text":"__opt_business_type_retail_store__"},
                    {"value":"SANITATION", "text":"__opt_business_type_sanitation__"},
                    {"value":"SECURITY_SERVICES", "text":"__opt_business_type_security_services__"},
                    {"value":"SENIOR_CARE_ASSISTED_LIVING", "text":"__opt_business_type_senior_care_assisted_living__"},
                    {"value":"SMOKE_SHOP", "text":"__opt_business_type_smoke_shop__"},
                    {"value":"SOLAR", "text":"__opt_business_type_solar__"},
                    {"value":"SPA_SERVICES", "text":"__opt_business_type_spa_services__"},
                    {"value":"STAFFING", "text":"__opt_business_type_staffing__"},
                    {"value":"TANNING_SALON", "text":"__opt_business_type_tanning_salon__"},
                    {"value":"TAX_PREPARATION", "text":"__opt_business_type_tax_preparation__"},
                    {"value":"TECHNOLOGY_COMPANY", "text":"__opt_business_type_technology_company__"},
                    {"value":"TRAVEL_TRANSPORTATION", "text":"__opt_business_type_travel_transportation__"},
                    {"value":"UNIFORM_SUPPLIER", "text":"__opt_business_type_uniform_supplier__"},
                    {"value":"VETERINARY_CLINIC", "text":"__opt_business_type_veterinary_clinic__"},
                    {"value":"WASTE_MANAGEMENT", "text":"__opt_business_type_waste_management__"},
                    {"value":"WHOLESALER", "text":"__opt_business_type_wholesaler__"},
                    {"value":"WINE_LIQUOR_STORE", "text":"__opt_business_type_wine_liquor_store__"},
                ],
                hideIfHasValue: false,
            },
            {
                label: '__payment_processor__',
                name: 'payment_processor',
                placeholder: '',
                as: 'input',
                type: 'select',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"value":"CHASE_PAYMENTECH", "text":"__opt_business_payment_processor_chase_paymentech__"},
                    {"value":"DEBITECH", "text":"__opt_business_payment_processor_debitech__"},
                    {"value":"DESJARDINS", "text":"__opt_business_payment_processor_desjardins__"},
                    {"value":"ELAVON", "text":"__opt_business_payment_processor_elavon__"},
                    {"value":"EVERLINK", "text":"__opt_business_payment_processor_everlink__"},
                    {"value":"FIRST_DATA", "text":"__opt_business_payment_processor_first_data__"},
                    {"value":"GLOBAL_PAYMENTS", "text":"__opt_business_payment_processor_global_payments__"},
                    {"value":"MERCURY_PAYMENTS", "text":"__opt_business_payment_processor_mercury_payments__"},
                    {"value":"MONERIS", "text":"__opt_business_payment_processor_moneris__"},
                    {"value":"MONEX", "text":"__opt_business_payment_processor_monex__"},
                    {"value":"PAYFIRMA", "text":"__opt_business_payment_processor_payfirma__"},
                    {"value":"PIVOTAL_PAYMENTS", "text":"__opt_business_payment_processor_pivotal_payments__"},
                    {"value":"POS_WEST", "text":"__opt_business_payment_processor_pos_west__"},
                    {"value":"SQUARE", "text":"__opt_business_payment_processor_square__"},
                    {"value":"STRIPE", "text":"__opt_business_payment_processor_stripe__"},
                    {"value":"TD_MERCHANT_SERVICES", "text":"__opt_business_payment_processor_td_merchant_services__"},
                    {"value":"OTHER", "text":"__opt_business_payment_processor_other__"},
                    {"value":"NONE", "text":"__opt_business_payment_processor_none__"},
                ],
                hideIfHasValue: false,
            },
        ],
        // hideButtonsSection: true,
    },
    {
        // beforeCreate: 'enablePartialRequestPerStep',
        beforeCreate: function() {},
        // beforeNextStep: 'executeEmailRegistrationCheck',
        // beforeNextStep: 'executeSubmitApplication',
        beforeNextStep: function() {},
        title: "__how_to_contact__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                // placeholder: 'First Name',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                // placeholder: 'Last Name',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                // placeholder: '__your_email__',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: '__province__',
                name: 'state',
                type: 'select',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"value":"AB", "text":"ALBERTA"},
                    {"value":"BC", "text":"BRITISH COLUMBIA"},
                    {"value":"MB", "text":"MANITOBA"},
                    {"value":"NB", "text":"NEW BRUNSWICK"},
                    {"value":"NL", "text":"NEWFOUNDLAND AND LABRADOR"},
                    {"value":"NS", "text":"NOVA SCOTIA"},
                    {"value":"ON", "text":"ONTARIO"},
                    {"value":"PE", "text":"PRINCE EDWARD ISLAND"},
                    {"value":"QC", "text":"QUEBEC"},
                    {"value":"SK", "text":"SASKATCHEWAN"},
                    {"value":"NT", "text":"NORTHWEST TERRITORIES"},
                    {"value":"NU", "text":"NUNAVUT"},
                    {"value":"YT", "text":"YUKON"},
                ],
                hideIfHasValue: false,
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                // placeholder: 'Your phone number',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
                textBottom: '__phone_number_sms_results__'
            },
            {
                // label: 'Credit Auth',
                label: false,
                name: 'opt_in',
                placeholder: '',
                as: 'input',
                type: 'checkbox',
                value: null,
                // validationRules: 'required',
                // fieldOuterClass: 'col-md-10 offset-md-1',
                fieldInnerClass: 'large-checkbox',
                // choices: [
                //     { "text":'__opt_opt_in_consent__', "value":true },
                // ]
                choices: (app) => {
                    if(app.projectBrandKey) {
                        if(app.projectBrandKey == 'lc') {
                            return [
                                { "text":'__opt_opt_in_consent__', "value":true },
                            ];
                        }
                        else if(app.projectBrandKey == 'comparehub') {
                            return [
                                { "text":'__opt_opt_in_consent_by_lc__', "value":true },
                            ];
                        }
                    }

                    return [
                        { "text":'__opt_opt_in_consent_by_comparehub__', "value":true },
                    ];
                },
            },
        ],
        // nextButtonText: '__submit__',
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
        textBottomBelowActionButtons: "__credit_history_authorization_1__"
    },
    {
        beforeCreate: function() {},
        beforeNextStep: 'executeSubmitApplication',
        title: "__sms_verification__",
        fields: [
            {
                // label: 'SMS Verification',
                name: 'sms_verification',
                type: 'smsverification',
                value: null,
                hideSubtitles: true,
            },
        ],
        hideButtonsSection: true,
        nextButtonText: '__skip__',
        nextButtonClass: 'btn-secondary',
        hideIfCondition: (app) => {
            return !app.forceSmsVerification;
        }
    },
];

export default steps;
